import NetsClickIdeationLayout from './nets_click_ideation_layout.jsx'

const NetsClickIdeationPage = () => {
  return (
      <NetsClickIdeationLayout />
  );
};

export default NetsClickIdeationPage;